import React, {useState} from 'react';
import s from './Transactions.module.css';
import UserInfo from '../../Components/User/UserInfo';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import GridTableHead from '../../Components/GridTableHead/GridTableHead';
import TableContent from '../../Components/TableCommonDirectory/TableElements/TableContent';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import {useBillingTransactionsListQuery} from '../../redux/userBillingApi';
import PreLoaderComponent from '../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import {
	RequestBillingTransactions,
	Transaction,
} from '../../types/TypesUserAccounts';
import {monthNow} from '../../assets/utils/dateUtils';
import TransactionsFilter from '../../Components/Filter/TransactionsFilter';
import {useTranslation} from 'react-i18next';
import FunctionalButtonPanel, {
	FunctionalButton,
} from '../../Components/FunctionalButtonPanel/FunctionalButtonPanel';
import LightGreenButton from '../../Components/Buttons/LightGreenButton';
import useClickMoreButton, {BaseFilters} from '../../hooks/useClickMoreButton';
import FilterToggleButton from '../../Components/Buttons/FilterToggleButton';

const Transactions: React.FC = () => {
	const [filters, setFilters] = useState<
		BaseFilters & RequestBillingTransactions
	>({
		month: monthNow(),
		offset: 0,
	});
	const {data: transactionsList, isLoading} =
		useBillingTransactionsListQuery(filters);
	const {t} = useTranslation();
	const apiData = useSelector((state: RootState) => state.appData.appData);
	const [active, setActive] = useState<boolean>(false);
	const [activeFilter, setActiveFilter] = useState<string | null>(null);
	const {handleClickMoreButton} = useClickMoreButton(setFilters);
	const functionalityButtons: FunctionalButton[] = [
		{
			name: t('Конвертація '),
			value: 'conversion',
			active: activeFilter === 'conversion',
		},
		{
			name: t('Отримання коштів'),
			value: 'withdrawal',
			active: activeFilter === 'withdrawal',
		},
		{
			name: t('Переведено до мене'),
			value: 'transfer-in',
			active: activeFilter === 'transfer-in',
		},
		{
			name: t('Переведено від мене'),
			value: 'transfer-out',
			active: activeFilter === 'transfer-out',
		},
	];
	const filterTransactions = (
		list: Transaction[] | undefined,
		activeFilter: string | null,
	): Transaction[] => {
		if (!list) return [];
		if (!activeFilter) return list; // если фильтр не выбран → показываем все
		return list.filter((item) => item.type === activeFilter);
	};
	const filteredList = filterTransactions(
		transactionsList?.transactions,
		activeFilter,
	);
	return (
		<div className="page__content">
			<TopTitleBlock title={apiData.text_transactions} />
			<div className="user__column">
				<UserInfo />
			</div>
			<FunctionalButtonPanel
				functionality={functionalityButtons}
				elWidth={'20'}
				callback={setActiveFilter}
			/>

			<div className={s.tableWrapper}>
				<div className={s.button}>
					<FilterToggleButton
						isActive={active}
						onClick={() => setActive(!active)}
						variant="green"
						activeText={t('закрити')}
						inactiveText={t('додати фільтр')}
					/>
				</div>
				<TransactionsFilter
					setFilters={setFilters}
					active={active}
					setActive={setActive}
				/>
				<div className={s.tableScrollContainer}>
					<GridTableHead
						columns={[
							apiData.text_col_transaction_id,
							apiData.text_col_account_from,
							apiData.text_sum,
							apiData.text_col_account_to,
							apiData.text_sum,
							apiData.text_col_status,
							apiData.text_col_actions,
						]}
						gridTemplateColumns="1fr 2fr 1fr 2fr 1fr 1fr 1fr"
					/>
					{isLoading ? (
						<PreLoaderComponent type={'circle'} size={'big'} />
					) : transactionsList ? (
						<>
							<TableContent transactions={filteredList} />
							{transactionsList && transactionsList.transactions.length > 9 && (
								<div className={s.buttonSeeMore}>
									<LightGreenButton
										text={t('Дивитися більше')}
										onClick={handleClickMoreButton}
										type={'button'}
									/>
								</div>
							)}
						</>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default Transactions;
